import React, { useState } from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';

import { Field } from 'react-final-form';
import { getOrgTermsContent } from '../../content/utils.js';
import FieldGroup from '../FieldGroup.jsx';
import DatePickerAdapter from '../DatePickerAdapter.jsx';

const EditMilestoneForm = ({
  data,
  handleSubmit,
  onUpdate,
  onDelete,
  values,
}) => {
  const [disabled, setDisabled] = useState(false);
  return (
    <form onSubmit={handleSubmit}>
      <Modal.Body>
        <Field
          name="name"
          className="m-0"
          placeholder="Milestone Title"
          type="text"
          label={getOrgTermsContent(
            data.project_id ? 'projectMilestone' : 'portfolioMilestone'
          )}
        >
          {(props) => (
            <FieldGroup
              {...props}
              onChange={(event) => onUpdate(event.target.value, 'name')}
            />
          )}
        </Field>
        <Field
          id="initiativeFormStartDate"
          name="date_at"
          label="Date"
          placeholderText="Click to select"
          component={DatePickerAdapter}
          onChange={(event) => onUpdate(event, 'date_at')}
          allowNull
        />
        <Field
          name="notes"
          componentClass="textarea"
          component={FieldGroup}
          rows={5}
          customClass="fixed-height"
          placeholder="Enter a Value"
          className="m-0"
          type="text"
          label="Note"
        >
          {(props) => (
            <FieldGroup
              {...props}
              // value={data.notes}
              onChange={(event) => onUpdate(event.target.value, 'notes')}
            />
          )}
        </Field>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <Col sm={6}>
            <Button
              block
              disabled={disabled}
              onClick={() => onDelete(data)}
              className="btn-danger"
            >
              Delete
            </Button>
          </Col>
          <Col sm={6}>
            <Button
              block
              bsStyle="primary"
              disabled={disabled}
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(values);
              }}
            >
              Save
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </form>
  );
};

export default EditMilestoneForm;
